import * as THREE from 'three';
import { thud } from './audio';
import { destroyBuilding } from './destruction';
import { buildings } from './entities';
import { dust } from './particles';
import { rig } from './scene';
import { BB, S, keys } from './state';
import { killCarsNear } from './traffic';
import { clamp, lerp } from './util';

export const _fwd = new THREE.Vector3(), _right = new THREE.Vector3(), _v = new THREE.Vector3(), _foot = new THREE.Vector3();
export function movePlayer(dt){
  const f = (keys.KeyW?1:0) - (keys.KeyS?1:0), r = (keys.KeyD?1:0) - (keys.KeyA?1:0);
  if (keys.KeyQ) rig.yaw += 1.2*dt; if (keys.KeyE) rig.yaw -= 1.2*dt;
  _fwd.set(-Math.sin(rig.yaw), 0, -Math.cos(rig.yaw)); _right.set(Math.cos(rig.yaw), 0, -Math.sin(rig.yaw));
  const want = _v.set(0,0,0).addScaledVector(_fwd, f).addScaledVector(_right, r);
  const speed = (keys.ShiftLeft||keys.ShiftRight) ? 92 : 52;
  if (want.lengthSq() > 0) want.normalize().multiplyScalar(speed);
  rig.vel.lerp(want, 1-Math.exp(-dt*6));
  const moving = rig.vel.length() > 3;
  rig.base.addScaledVector(rig.vel, dt);
  const lim = BB.half + 140; rig.base.x = clamp(rig.base.x, -lim, lim); rig.base.z = clamp(rig.base.z, -lim, lim);
  if ((Math.abs(rig.base.x) >= lim || Math.abs(rig.base.z) >= lim) && performance.now() - edgeT > 12000){ edgeT = performance.now(); toast('Edge of the block', 'the mapped city ends here — turn back'); }
  // photo world: stand on the street, not on whatever the photo mesh has under one foot (cars, trees, awnings)
  if (S.world==='photo'){
    walk.t += dt; if (walk.t > 0.1){ walk.t = 0; walk.target = streetLevel(rig.base.x, rig.base.z, walk.target); }
    const diff = walk.target - rig.ground, maxStep = 4*dt;   // slopes read as slopes; steps never reach the camera
    rig.ground += clamp(diff*(1-Math.exp(-dt*2.2)), -maxStep, maxStep);
  } else rig.ground = 0;
  S.walked += rig.vel.length()*dt;
  // footsteps
  if (moving){
    rig.stepPhase += dt * rig.vel.length() / 30;
    const sgn = Math.sin(rig.stepPhase) >= 0 ? 1 : -1;
    if (sgn !== rig.lastStepSign){ rig.lastStepSign = sgn;
      const side = sgn > 0 ? 1 : -1;
      _foot.copy(rig.base).addScaledVector(_fwd, 14).addScaledVector(_right, side*9); _foot.y = rig.ground;
      rig.shake = Math.max(rig.shake, 0.55 + 0.6*(speed/92));
      thud(0.5 + 0.5*(speed/92));
      for (let i=0;i<22;i++) dust.emit(_foot, new THREE.Vector3(0,3,0), 16, 1.6);
      killCarsNear(_foot.x, _foot.z, 11, 25);
    }
    rig.bob = Math.abs(Math.sin(rig.stepPhase))*2.4;
  } else rig.bob = lerp(rig.bob, 0, 1-Math.exp(-dt*8));
  // stomp / collide
  const px = rig.base.x, pz = rig.base.z;
  for (let i=buildings.length-1;i>=0;i--){
    const b = buildings[i], u = b.userData;
    const dx = u.center.x-px, dz = u.center.z-pz; const d = Math.hypot(dx,dz) - u.fr*0.8;
    if (u.h < rig.h*0.32){ if (d < 16){ if (mpHooks.crush){ if (!u.pendingCrush){ u.pendingCrush = true; mpHooks.crush(b); } } else destroyBuilding(b, new THREE.Vector3(px,0,pz), true); } }
    else if (d < 10){ const L = Math.hypot(dx,dz)||1; rig.base.x -= dx/L*(10-d); rig.base.z -= dz/L*(10-d); rig.vel.multiplyScalar(0.2); }
  }
}

import { mpHooks } from './destruction';
import { streetLevel } from '../world/tiles';
const walk = { t: 1, target: 0 }; let edgeT = -1e9;
import { toast } from './hud';
// called when a run starts: stand on the street immediately instead of easing up from sea level
export function snapGround(){ walk.target = S.world==='photo' ? streetLevel(rig.base.x, rig.base.z, 0) : 0; rig.ground = walk.target; walk.t = 1; }
